$( document ).ready(function() {
    if(document.getElementById('contenido_formato')){
        console.log("encontrado");
        tinyMCE.baseURL = `${url_base}/js/tinymce`;
        tinyMCE.init({
            height : "45vh",
            selector: '#contenido_formato',
            theme_url: `${url_base}/js/tinymce/themes/silver/theme.min.js`,
            language_url : `${url_base}/js/tinymce/langs/es.js`,
            language: 'es',
            plugins: [
                'lists',
                'link',
                'searchreplace',
                'charmap',
                'autolink',
                'code',
                'table',
                'paste',
                'image',
                'wordcount',
                'insertdatetime',
                'visualblocks',
                'advlist'
            ],
            toolbar: 'undo redo | styles | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image | print media | forecolor backcolor',
        });
    }
});
previewFormato = function(id){
    axios.get(url_base+'/formatos/'+id+'/stream/pdf',{
        _token: token.content
    })
        .then(response => {
            console.log(response);
            if(response.data.preview){
                //setTimeout(function(){
                    document.getElementById('previsualizar_formato_div').innerHTML=response.data.preview;
                //},1000);
            }
        })
        .catch(e => {
            console.log(e);
        });
}
eliminarFormato = function(e){
    let data = e.dataset;
    document.getElementById('modalEliminarFormatoLabel').innerHTML=data.nombre;
    document.getElementById('formato_eliminar_id').value=data.id;
}
insertarEtiqueta = function (etiqueta){
    if (etiqueta.indexOf("[") >= 0 && etiqueta.indexOf("]") >= 0) {
        tinyMCE.activeEditor.execCommand('mceInsertContent', false, "<b>" + etiqueta + "</b>");
    } else {
        tinyMCE.activeEditor.execCommand('mceInsertContent', false, etiqueta);
    }
}
$(".tabla_etiquetas").DataTable({
    dom: '<"d-flex justify-content-between"><"col-md-6 p-0 my-3 float-end"f>tp',
    pageLength:8,
    language: {
        url: url_base+'/vendor/datatables/spanish.json'
    },
    order: [[0, 'desc']],
});
